import React from 'react';
import { motion } from 'framer-motion';

const ecosystemItems = [
    { name: 'ERP Lukos', detail: 'Gestão Centralizada' },
    { name: 'PDV Móvel', detail: 'Vendas na Pista' },
    { name: 'NFC-e & NF-e', detail: 'Fiscal Integrado' },
    { name: 'Cartões & PIX', detail: 'Baixa Automática' },
    { name: 'Estoque Real', detail: 'Controle de Tanques' },
    { name: 'Fidelidade', detail: 'Retenção de Clientes' },
    { name: 'WhatsApp Bot', detail: 'Atendimento IA' },

];

const PartnersSection = () => {
    return (
        <section className="py-4 bg-[#8B5CF6] overflow-hidden">
            {/* Static Ribbon Wrapper */}
            <div className="container mx-auto px-6">
                <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8">
                    {ecosystemItems.map((item, index) => (
                        <div
                            key={index}
                            className="flex items-center gap-3 px-4 py-2 transition-all group"
                        >
                            <div className="w-1.5 h-1.5 rounded-full bg-white/40 group-hover:bg-white group-hover:scale-125 transition-all" />
                            <div className="flex flex-col">
                                <span className="text-white font-bold text-sm md:text-base uppercase tracking-tight">
                                    {item.name}
                                </span>
                                <span className="text-white/50 font-medium text-[9px] uppercase tracking-widest leading-none">
                                    {item.detail}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>


        </section>
    );
};

export default PartnersSection;
